import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from "axios";
import config from '../Common/Configurations/APIConfig';

const allTimeZones = Intl.supportedValuesOf('timeZone');

const RegisterSalon = () => {
    const navigate = useNavigate();
    const [btnLoading, setBtnLoading] = useState(false);
    
    const [values, setValues] = useState({
        name: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        password: ''
    });

    const [errors, setErrors] = useState({});

    const handleInput = (e) => {
        setValues({ ...values, [e.target.name]: e.target.value });
    };

    const validate = () => {
        let temp = {};
        temp.name = values.name ? "" : "Salon Name is required";
        temp.email = (/$^|.+@.+..+/).test(values.email) ? "" : "Email is not valid";
        temp.password = values.password.length >= 6 ? "" : "Password must be at least 6 characters";
        setErrors(temp);
        return Object.values(temp).every(x => x === "");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            setBtnLoading(true);
            try {
                const url = config.APIACTIVEURL + config.CREATESALON;
                const response = await axios.post(url, values);

                if (response.data.success) {
                    alert("Registration Successful!");
                    navigate('/'); // Redirect to login after success
                }
            } catch (error) {
                alert(error.response?.data?.message || "Registration failed");
            } finally {
                setBtnLoading(false);
            }
        }
    };

    return (
        <div className="container d-flex justify-content-center align-items-center min-vh-100" style={{ paddingTop: '100px', paddingBottom: '50px' }}>
            <div className="card border-0 shadow-lg p-4 w-100" style={{ maxWidth: '600px', borderRadius: '2rem' }}>
                <div className="text-center mb-4">
                    <h2 className="fw-bold">Business Registration</h2>
                    <p className="text-muted">Register your salon to start managing appointments</p>
                </div>

                <form className="row g-3" onSubmit={handleSubmit}>
                    <div className="col-md-12">
                        <label className="form-label fw-bold">Salon Name</label>
                        <input type="text" name="name" value={values.name} onChange={handleInput} className={`form-control py-3 rounded-3 ${errors.name ? 'is-invalid' : ''}`} placeholder="Enter Salon Name" />
                        {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>

                    <div className="col-md-6">
                        <label className="form-label fw-bold">Business Email</label>
                        <input type="email" name="email" value={values.email} onChange={handleInput} className={`form-control py-3 rounded-3 ${errors.email ? 'is-invalid' : ''}`} placeholder="email@example.com" />
                        {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    </div>

                    <div className="col-md-6">
                        <label className="form-label fw-bold">Business Phone</label>
                        <input type="tel" name="phone" value={values.phone} onChange={handleInput} className="form-control py-3 rounded-3" placeholder="Phone Number" />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label fw-bold">City</label>
                        <input type="text" name="city" value={values.city} onChange={handleInput} className="form-control py-3 rounded-3" placeholder="City" />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label fw-bold">Password</label>
                        <input type="password" name="password" value={values.password} onChange={handleInput} className={`form-control py-3 rounded-3 ${errors.password ? 'is-invalid' : ''}`} placeholder="******" />
                        {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                    </div>

                    <div className="col-12">
                        <label className="form-label fw-bold">Preferred TimeZone</label>
                        <select name="timeZone" value={values.timeZone} onChange={handleInput} className="form-select py-3 rounded-3">
                            {allTimeZones.map((tz) => (
                                <option key={tz} value={tz}>{tz.replace(/_/g, ' ')}</option>
                            ))}
                        </select>
                    </div>

                    <div className="col-12">
                        <label className="form-label fw-bold">Address</label>
                        <textarea name="address" value={values.address} onChange={handleInput} className="form-control rounded-3" rows="2" placeholder="Full Business Address"></textarea>
                    </div>

                    <div className="col-12 text-center mt-4">
                        <button type="submit" disabled={btnLoading} className="btn py-3 px-5 text-white fw-bold rounded-3 w-100 shadow-sm" style={{ backgroundColor: '#136e68' }}>
                            {btnLoading ? 'Processing...' : 'Register Business'}
                        </button>
                        <p className="mt-3">Already have an account? <Link to="/" className="fw-bold text-decoration-none" style={{ color: '#136e68' }}>Login</Link></p>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RegisterSalon;